export default function getModuleKeyFromSkill(skill) {
  const skillName = skill.skillName;
  let moduleKeyName = skillName;
  if (skill.subSkills.some((subSkill) => subSkill.sequence)) {
    const moduleName = skillName.split(" ")[0];
    const moduleNumber = skillName.split(" ")[1];
    moduleKeyName = moduleName + " " + moduleNumber;
  }
  return moduleKeyName;
}